// Set by the service worker once a newer build is active, so the router can switch to it
// with a full page load on the next navigation instead of reloading while the user is
// in the middle of something. Kept free of imports so the router can use it without
// pulling in apiClient (which imports the router).
let pendingReload: ((href: string) => void) | null = null;

export const markUpdateReady = (reload: (href: string) => void): void => {
  pendingReload = reload;
};

// Returns true when the navigation is being replaced by a full page load to href
export const applyPendingUpdate = (href: string): boolean => {
  if (!pendingReload) return false;
  const reload = pendingReload;
  pendingReload = null;
  reload(href);
  return true;
};
